import { adminRepositories } from "data/admin/repositories";

function aggregateFavorites(docs) {
  const provinceIds = new Set();
  const dealIds = new Set();
  for (const doc of docs) {
    (doc.provinceIds || []).forEach((id) => provinceIds.add(id));
    (doc.dealIds || []).forEach((id) => dealIds.add(id));
  }
  return {
    provinceIds: Array.from(provinceIds),
    dealIds: Array.from(dealIds),
    users: docs,
  };
}

export const favoritesRepo = {
  /** Tüm kullanıcı favorilerinin birleşik özeti (admin). */
  get() {
    const docs = adminRepositories.userFavorites.list({ includeDeleted: false });
    return aggregateFavorites(docs);
  },

  listUsers() {
    return adminRepositories.userFavorites.list({ includeDeleted: true });
  },

  getByUserId(userId) {
    return (
      adminRepositories.userFavorites.getById(userId) || {
        id: userId,
        userId,
        provinceIds: [],
        dealIds: [],
      }
    );
  },

  saveForUser(userId, patch) {
    const existing = adminRepositories.userFavorites.getById(userId);
    if (existing) {
      return adminRepositories.userFavorites.update(userId, patch);
    }
    return adminRepositories.userFavorites.create({
      id: userId,
      userId,
      provinceIds: patch.provinceIds || [],
      dealIds: patch.dealIds || [],
    });
  },
};
